module.exports = __webpack_public_path__ + "img/wa-line1.9c388c7.png";